import { render, staticRenderFns } from "./UserDetailsDialog.vue?vue&type=template&id=6188d8dc&scoped=true"
import script from "./UserDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UserDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsDialog.vue?vue&type=style&index=0&id=6188d8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188d8dc",
  null
  
)

export default component.exports